import Vue from "vue";
import App from "./App.vue";
import VueRouter from "vue-router";
import Buefy from "buefy";

import { library } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { faCirclePlus } from "@fortawesome/free-solid-svg-icons";
import { ValidationObserver, ValidationProvider } from "vee-validate";
library.add(faCirclePlus);

import MenuIcon from "vue-material-design-icons/Menu.vue";
// country flags
import "/node_modules/flag-icons/css/flag-icons.min.css";
import NoticeInfo from "./components/NoticeInfo.vue";
import IdentityProof from "./components/IdentityProof.vue";
import EnterNic from "./components/EnterNIC.vue";
import LanguageSelection from "./components/LanguageSelection.vue";
import EnterOtp from "./components/EnterOtp.vue";
import ContactInfo from "./components/ContactInfo.vue";
import PersonalInformation from "./components/PersonalInformation.vue";
import PurposeInfo from "./components/PurposeInfo.vue";
import EmploymentInfo from "./components/EmploymentInfo.vue"
import BusinessInfo from "./components/BusinessInfo.vue";
import Documents_ID from "./components/Documents_ID.vue";
import Document_Passport from "./components/Document_Passport.vue";
import PreviewPage from "./components/PreviewPage.vue";
import VerificationInfo from "./components/VerificationInfo.vue";
import CongratulationsPage from "./components/CongratulationPage.vue";
import EnterName from "./components/EnterName.vue"; //rdb v-2
import InfoPage from "./components/InfoPage.vue"; //rdb v-2
import AccountHolder from "./components/AccountHolder.vue"; //rdb v-2
import VideoCallDetails from "./components/VideoCallDetails" //rdb v-2
import AccountInfo from "./components/AccountInfo.vue";
import Information from "./components/Information.vue";
import GuardiansInformation from "./components/GuardiansInformation.vue";
import WelcomeBack from "./components/WelcomeBack.vue";
import VasInfo from "./components/VasInfo.vue";
import ToggleSwitch from "vuejs-toggle-switch";
import * as enLanguageData from "./assets/Lang/en.json";
import * as siLanguageData from "./assets/Lang/si.json";
import * as taLanguageData from "./assets/Lang/ta.json";

import "../src/myBuefyStyles/myBuefyStyles.scss";

import axios from "axios";
Vue.prototype.$http = axios;

import config from "@/config";
Vue.prototype.$baseURL = config.baseUrl;
Vue.prototype.$storageURL = config.storageUrl;

import gsap from "gsap";
Vue.prototype.$gsap = gsap;

import animations from "@/assets/js/animations";
Vue.prototype.$animations = animations.animations;
// Keystroke calculation methods
import keystrokeCalculations from "@/assets/js/keystrokeCalculations";

Vue.prototype.$inputFocused = keystrokeCalculations.inputFocused;
Vue.prototype.$inputChanged = keystrokeCalculations.inputChanged;
Vue.prototype.$inputBlured = keystrokeCalculations.inputBlured;

// import "buefy/dist/buefy.css";
Vue.component("menu-icon", MenuIcon);
Vue.component("font-awesome-icon", FontAwesomeIcon);
Vue.component("ValidationProvider", ValidationProvider);
Vue.component("ValidationObserver", ValidationObserver);
Vue.use(ToggleSwitch);
Vue.use(VueRouter);
Vue.use(Buefy);

// Vue.config.productionTip = false;

const router = new VueRouter({
  routes: [
    {
      path: "/",
      component: LanguageSelection,
    },
    {
      path: "/notice_info",
      component: NoticeInfo,
    },
    {
      path: "/identity-proof",
      component: IdentityProof,
    },
    {
      path: "/enter-name", //added in ndb v2
      component: EnterName,
    },
    {
      path: "/video-call-schedule", //added in ndb v2
      component: VideoCallDetails,
    },
    {
      path: "/info-page", //added in ndb v2
      component: InfoPage,
    },
    {
      path: "/account-info", //added in ndb v2
      component: AccountInfo,
    },
    {
      path: "/account-holder-info", //added in ndb v2
      component: AccountHolder,
    },
    {
      path: "/nic",
      component: EnterNic,
    },
    {
      path: "/contact-info",
      component: ContactInfo,
    },
    {
      path: "/otp",
      component: EnterOtp,

    },
    {
      path: "/personal-info",
      component: PersonalInformation,
    },
    {
      path: "/information",
      component: Information,
    },
    {
      path: "/purpose",
      component: PurposeInfo,
    },
    {
      path: "/employment_info",
      component: EmploymentInfo,
    },
    {
      path: "/business-info",
      component: BusinessInfo,
    },
    {
      path: "/documents_id",
      component: Documents_ID,
    },
    {
      path: "/document_passport",
      component: Document_Passport,
    },
    {
      path: "/guardians_information",
      component: GuardiansInformation,
    },
    {
      path: "/VasInfo",
      component: VasInfo,
    },
    // {
    //   path: "/socialmedia",
    //   component: SocialMedia,
    // },

    {
      path: "/preview-page",
      component: PreviewPage,
    },
    {
      path: "/verification",
      component: VerificationInfo,
    },
    {
      path: "/congratulation",
      component: CongratulationsPage,
    },

    {
      path: "/welcome-back",
      component: WelcomeBack,
    },


    //   // test route added to fixed blank page issue in deployment
    // {
    //   path: '*',
    //   name: 'catchAll',
    //   component: LanguageSelection
    // }
  ],
  base: process.env.BASE_URL,
  mode: "history",
  // eslint-disable-next-line no-unused-vars
  scrollBehavior(to, from, savedPosition) {
    // always scroll to top
    return { x: 0, y: 0 };
  },
});

new Vue({
  router,
  data: {
    selecteableTimeSlotsArray : [],
    isPreviouslyDonorFilled : 0,
    isFromStatusCheck : 0,

    dataLists : {
      branchListArray: [],
      otherBankAndBranchList: [],
      selectBankBranches : [],
      countryCodeNumbersListArray : [],
      countryCodeListArray : []
    },

    formData: {
            currentTime: "",
      countryCodeListArray: [],
      countryCodeNumbersListArray: [],
      branchListArray: [],
      countriesList: [], // an array type variable to store all active countries
      idType: "",
      idProofType: "",
      haveNic: "",
      customer_nic: "",
      customer_passport_no: "",
      nicNumberAllowToDRP: true,
      nicNumberAllowToLocationServicesInYourBrowser: true,
      statusEmail:"",
      statusNic:"",
      childrenAccountOpeningPurpose : "",

      donorResidentCountry : "",
      donorResidentship: "",

      

      email: "",
      otp: "",

      accountImage : "",

      full_name: "",
      surname: "",
      other_name: "",
      mobileNumber: "",
      mobileNumberWithoutCountryCode: "",
      account_type: "",
      account: "",
      account_name: '',
      account_time_period: "",
      country: "",
      country_short_name: "",
      countryCode: "+94",
      mobileNumberCountrySelectionTemp: "",
      branch: "",
      srilankanCurrencyType: "LKR",
      forignCurrencyType: "",
      contact_no: "",
      locationService: false,
      isUserAgree:false,

      donorsName : "",
      isAgreeToNominees : false,
      addAnotherNominee : false,
      addThirdNominee : false,
      nomineesData : [{name : '', gender : '', houseName : '', streetName : '', city : '', postalCode : '', country : '', nic : '', dob : '', relationship : '', share : ''}, {name : '', gender : '', houseName : '', streetName : '', city : '', postalCode : '', country : '', nic : '', dob : '', relationship : '', share : ''}, {name : '', gender : '', houseName : '', streetName : '', city : '', postalCode : '', country : '', nic : '', dob : '', relationship : '', share : ''}],
      nomineeDataObj : {name : '', gender : '', address : '', nic : '', dob : '', relationship : '', share : ''},
      interestPayable : "",
      interestPayment : "",
      transferAccount : "",
      otherBank : "",
      otherBankBranch : "",
      otherBankAndBranchList : [],
      fixedAccountTimeDurations : [],
      selectBankBranches: [],
      otherBankAccountNumber: "",
      otherBankAccountHolderName : "",
      productListArray : [],
      isShareOnLimit : true,
      sameNic : false,
      opendAccountType : "",


      // contactNumberImgLogo: `fi fi-${this.formData.countryCode}`,
      // officeContactNumberImgLogo: "",
      // residenceContactNumberImgLogo: "",
      countryIconString:` fi fi-lk`,
      countryIconStringOffice: ` fi fi-lk`,
      countryIconStringResidance: `fi fi-lk`,
      officeCountryCode: "+94",
      residenceCountryCode: "+94",
      officeContactNum: "",
      officeContactNumWithOutCode: "",
      residanceContactNum: "",
      residanceContactNumWithOutCode: "",
      title: "",
      name_with_init: "",
      countryCodeForResidentialContactNum: "",
      countryCodeForResidentialContactNumTemp: "",
      resident_country_short_name: "",
      office_country_short_name: "",
      countryCodeForOfficeContactNum: "",
      countryCodeForOfficeContactNumTemp: "",
      contact_no_resident: "",
      residentNumber: "",
      officeNumber: "",
      contact_no_work: "",
      gender: "",
      customer_gender: "",
      customerAge : '',
      customer_dob: "",
      date_of_birth: "",
      marital_status: "",
      spouse_name: "",
      foreign_address_line1: "",
      foreign_address_line2: "",
      foreign_address_line3: "",
      foreign_address_postal_code: "",
      foreign_address_country: "",
      permanent_address_line1: "",
      permanent_address_line2: "",
      permanent_address_line3: "",
      permanent_address_postal_code: "",
      permanent_address_country: "",
      mailing_address_line1: "",
      mailing_address_line2: "",
      mailing_address_line3: "",
      mailing_address_postal_code: "",
      mailing_address_country: "",
      correspondent_address_line1: "",
      correspondent_address_line2: "",
      correspondent_address_line3: "",
      correspondent_address_postal_code: "",
      correspondent_address_country: "",
      donor_permanent_address_line1: "",
      donor_permanent_address_line2: "",
      donor_permanent_address_line3: "",
      donor_permanent_address_postal_code: "",
      donor_permanent_address_country: "",
      donor_mailing_address_line1: "",
      donor_mailing_address_line2: "",
      donor_mailing_address_line3: "",
      donor_mailing_address_postal_code: "",
      donor_mailing_address_country: "",
      donor_mailing_address_same_as_permanent_address: false,
      residentialAddress: "",
      mailing_address_same_as_permanent_address: false,
      foreignAddress: "",
      selectStateOfPermanentAddress: "",
      citizenship: "Sri Lankan",
      dual_citizen_countries: [],
      foreign_national_country: "",
      residentship: "",
      us_person: "",
      resident_countries: [],
      resident_country: "",
      citizenship_country: "",
      politically_exposed: "",
      politically_exposed_position: "",
      politically_exposed_relative: "",
      politically_exposed_relative_position: "",
      specified_designation: "",
      // is_guardian_same_passport_number: false,

      guardian_title: "",
      guardian_surname: "",
      guardian_other_name: "",
      guardian_gender: "",
      guardian_marital_status: "",
      guardian_spouse_name: "",
      guardian_details_are_different: false,
      guardian_nationality_citizenship: "",
      guardian_countryCode: "",
      guardian_country_short_name: "",
      guardian_mobileNumber: "",
      guardian_contact_no: "",
      guardian_email: "",
      guardian_nic: "",
      guardian_driving_licence: "",
      account_holder_driving_licence: "",
      guardian_passport: "",
      guardian_passport_issue_date: "",
      account_holder_passport_issue_date: "",
      account_holder_passport_expiry_date: "",
      guardian_passport_expiry_date: "",
      guardian_house_name: "",
      guardian_street_name: "",
      guardian_city: "",
      guardian_postal_code: "",
      guardian_country: "",
      guardian_mailing_address_different: false,
      guardian_mailing_house_name: "",
      guardian_mailing_street_name: "",
      guardian_mailing_city: "",
      guardian_mailing_postal_code: "",
      guardian_mailing_country: "",
      guardian_us_person: "",
      guardian_acc_num: "",
      guardian_place_of_birth: "",
      guardian_us_permanent_address_different: false,
      guardian_us_house_name: "",
      guardian_us_street_name: "",
      guardian_us_city: "",
      guardian_us_postal_code: "",
      guardian_us_country: "",
      guardian_us_mailing_address_different: false,
      guardian_us_mailing_house_name: "",
      guardian_us_mailing_street_name: "",
      guardian_us_mailing_city: "",
      guardian_us_mailing_postal_code: "",
      guardian_us_mailing_country: "",
      guardian_us_passport: "",
      guardian_tax_idetification_number: "",
      guardian_are_you_a_tax_payer: "",
      guardian_tax_file_number: "",
      guardian_political_exposed: "",
      guardian_political_exposed_position: "",
      guardian_closer_relatives_politically_exposed: "",
      guardianDob : "",
      guardian_residency: "",
      guardian_resident_country : "",
      guardian_citizenship_country : "",
      relationship_to_the_acc_holder : "",
      guardianUsTellCountryCode : "US",
      guardian_us_tel_number : "",
      guardian_us_person_telephone_no : "",

      countryCodeForGuardianResidentialContactNum : "",
      countryCodeForGuardianResidentialContactNumTemp : "",
      guardianResidentNumber : "",
      guardian_contact_no_resident : "",
      guardian_resident_country_short_name : "",
      guardianResidenceCountryCode : "+94",
      guardianCountryIconStringResidance : "fi fi-lk",
      guardianResidanceContactNumWithOutCode : "",

      countryCodeForGuardianOfficeContactNum : "",
      countryCodeForGuardianOfficeContactNumTemp : "",
      guardianOfficeNumber : "",
      guardian_contact_no_work : "",
      guardianOfficeCountryCode : "+94",
      guardianCountryIconStringOffice : "fi fi-lk",
      guardianOfficeContactNumWithOutCode : "",
      guardian_office_country_short_name : "",





      sms_service: true,
      e_banking_service: true,
      virtual_wallet_service: true,
      estatement_service: true,
      debit_card_service: true,
      pos_required: false,
      account_to_be_linked: "",
      facility_debit_card_customer_name: "",
      mother_maiden_name: "",
      card_delivery: "",
      card_pin_delivery: "",
      facility_debit_card_type: "",

      occupation: "",
      other_occupation: "",
      school: "",
      grade: "",
      account_holder_residentship: "",
      account_holder_residentship_country: "",
      account_holder_citizenship: "",
      account_holder_citizenship_country: "",
      account_holder_dob: "",



      us_person_account_numbers: "",
      us_person_place_of_birth: "",
      us_person_permanent_address: "",
      permanent_address_in_us_radio: "",
      correspondent_address_in_us: "",
      us_person_correspondent_address: "",
      usTellCountryCode: "",
      us_tel_number: "",
      us_person_telephone_no: "",
      us_person_tax_identification_no: "",
      same_as_above_passport_number: false,
      us_person_passport_no: "",
      same_passport_number: false,
      same_guardian_passport_number : false,

      address_in_us_same_as_permanent_address: "",
      us_person_permanent_address_line1: "",
      us_person_permanent_address_line2: "",
      us_person_permanent_address_line3: "",
      us_person_permanent_address_postal_code: "",
      us_person_permanent_address_country: "United States America",

      mailing_address_in_us_same_as_permanent_address_in_us: false,
      us_person_mailing_address_line1: "",
      us_person_mailing_address_line2: "",
      us_person_mailing_address_line3: "",
      us_person_mailing_address_postal_code: "",
      us_person_mailing_address_country: "United States America",

      residentialProperty: false,
      motorVehicle: false,
      landBuilding: false,
      investmentShares: false,
      others: false,

      tax_payer: "",
      tax_file_number: "",

      purpose_of_opening: "",
      other_purpose_of_opening: "",
      source_of_income: "",
      other_source_of_income:"",
      other_source_of_fund: "",
      source_of_fund: "",
      income_details: "",
      expected_turnover: "",
      anticipated_vol: "",
      expected_delivery_channel: "",
      expected_mode_of_transaction: "",
      other_expected_mode_of_transaction: "",

      other_assets_held: "",
      asset_residential_property: false,
      asset_financial: false,
      asset_motor_vehicles: false,
      asset_land_buildings: false,   //consider this value as business value
      asset_investments_shares: false,
      asset_other: false,
      asset_residential_property_value: "",
      asset_investments_shares_value: "",
      asset_land_buildings_value: "",
      asset_motor_vehicles_value: "",
      asset_financial_value: "",
      asset_other_value: "",
      isDonorFilled : 0,


      //Newly added fields for RDB v2
      userEnteredNic: "",

      account_holder_passport_number : "",
      country_code : "",


      assetsCheck: {
        residentialProperty: {isHave : false, amount: null},
        financialAssets:  {isHave : false, amount: null},
        business:  {isHave : false, amount: null},
        investment:  {isHave : false, amount: null},
        motorVehicles:  {isHave : false, amount: null},
        other:  {isHave : false, amount: null},
      },

      valueofresidentialProperty: "",
      valueofmotorVehicle: "",
      valueoflandBuildings: "",
      valueofinvestmentShares: "",
      valueofothers: "",

      other_businesses: "",

      natureOfEmployment: "",
      employment_position: "",
      employment_position_specify: "",
      employer_name: "",
      employer_addr: "",
      employer_name_spouse: "",
      employment_position_spouse: "",
      Otp: "",

      agree_with_the_verification_attached: "",
      introduced_by: "",

      selLang: "",

      currencies: [],
      currency_type_raw: "",
      currency_type_code: "",
      currency_type: "LKR",

      videoCallDate: "",
      videoCallTimeSlot: "",

      addressProofSameAsNic: false,

      initialOTP: "",
      finalOTP: "",

      kyc_token: "",
      // a variable to store the face id values
      face_ids: {
        nic: null,
        selfie: null,
      },

      location_details: {
        form_submitted: null,
      },

      locationAccess: "",
      nicVerificationDRP: "",

      color_code1: "",
      color_code2: "",
      color_code3: "",
      color_code4: "",
      color_code5: "",
      color_code6: "",
      color_code7: "",
      color_code8: "",
      color_code9: "",
      color_code10: "",
      color_code11: "",
      color_code12: "",
      color_code13: "",
      color_code14: "",
      color_code15: "",
      color_code16: "",
    },

    productImages: {
      nic_front_image: null,
      nic_back_image: null,
      selfie_image: null,
      sign_image: null,
      addr_proof_doc: null,
      passport_image: null,
      visa_proof_doc: null,
      birth_certificate_front_image: null,
      birth_certificate_back_image: null,
      passport_bio_page_image: null,
      passport_alteration_page_image: null,
      passport_entry_stamp_page_image: null,
      guardian_passport_bio_page_image: null,
      guardian_passport_alteration_page_image: null,
      guardian_passport_entry_stamp_page_image: null,
      driving_licence_image: null,
    },

    imageurl: {
      nicfrontsideimageurl: null,
      nicbacksideimageurl: null,
      selfie_imageurl: null,
      signature_imageurl: null,
      address_proof_imageurl: null,
      passportimageurl: null,
      visa_proof_imageurl: null,
      birth_certificate_front_imageurl: null,
      birth_certificate_back_imageurl: null,
      passport_bio_page_imageurl: null,
      passport_alteration_page_imageurl: null,
      passport_entry_stamp_page_imageurl: null,
      guardian_passport_bio_page_imageurl: null,
      guardian_passport_alteration_page_imageurl: null,
      guardian_passport_entry_stamp_page_imageurl: null,
      driving_licence_imageurl: null,

    },

    keyStrokeStatics: {
      kyc_branch: 0,
      idProofType: 0,
      account_type: 0,
      mobileNumber: 0,
      residentNumber: 0,
      officeNumber: 0,
      us_person: 0.2,
      us_person_account_numbers: 0,
      us_person_place_of_birth: 0,
      us_person_permanent_address: 0,
      us_person_correspondent_address: 1,
      us_person_passport_no: 0,
      us_person_telephone_no: 0,
      dual_citizen_countries: 0.4,
      us_person_tax_identification_no: 0,
      facility_internet_banking: 0,
      facility_debit_card: 0,
      facility_debit_card_type: 0,
      facility_debit_card_customer_name: 0,
      foreign_national_country: 0,
      resident_countries: 0.1,
      visa_proof_doc: 0.1,
      contact_no: 0,
      contact_no_resident: 0.33,
      contact_no_work: 0,
      email: 0,
      title: 0.1,
      name_with_init: 0,
      full_name: 0.3,
      customer_nic: 0,
      gender: 0,
      // date_of_birth: 0,
      marital_status: 0,
      spouse_name: 0,
      permenent_addr: 0.09000000000000001,
      address_line_1: 0,
      address_line_2: 0.27,
      address_line_3: 0,
      residential_addr: 0,
      foreign_addr: 0.22,
      residential_ownership: 0,
      citizenship: 0.2,
      residentship: 0,
      politically_exposed: 0,
      politically_exposed_relative: 0.2,
      nature_of_business: 0,
      employment_position: 0,
      employment_position_spouse: 0,
      employer_name: 0.4,
      employer_name_spouse: 0,
      employer_addr: 0,
      purpose_of_opening: 0,
      source_of_income: 0,
      income_details: 0.1,
      anticipated_vol: 0,
      expected_delivery_channel: 0,
      other_businesses: 0,
      nic_front_image: 0,
      nic_back_image: 0,
      birth_certificate_front_image: 0,
      birth_certificate_back_image: 0,
      passport_bio_page_image: 0,
      passport_alteration_page_image: 0,
      passport_entry_stamp_page_image: 0,
      driving_licence_image: 0,
      passport_image: 0,
      selfie_image: 0,
      sign_image: 0,
      addr_proof_doc: 0,
      asset_residential_property: 0,
      asset_motor_vehicles: 0,
      asset_land_buildings: 0,
      asset_investments_shares: 0,
      asset_other: 0,
      other_purpose_of_opening: 0,
      asset_residential_property_value: 0,
      asset_motor_vehicles_value: 0,
      asset_land_buildings_value: 0,
      asset_investments_shares_value: 0,
      asset_other_value: 0.36,
      vas_visa_card: 0,
      vas_visa_card_name: 0,
      vas_lkr_online_purchase: 0,
      vas_fc_transaction: 0,
      vas_sms_alerts: 0,
      vas_sms_alerts_mobile: 0,
      vas_all_transaction_alerts: 0,
      vas_mothers_maiden_name: 0,
      indemnity: 0,
      special_declaration_q1: 0,
      special_declaration_q1_country: 0,
      special_declaration_q2: 0,
      special_declaration_q2_country: 0,
      special_declaration_q3: 0,
      special_declaration_q3_country: 0,
      special_declaration_q4: 0,
      special_declaration_q4_period: 0,
      special_declaration_q5: 0,
      facebook_name: 0,
      linkedin_name: 0,
      twitter_name: 0,

      // newly added fields------------------- 2022-09-22
      foreign_address_line1: 0,
      foreign_address_line2: 0,
      foreign_address_line3: 0,
      foreign_address_postal_code: 0,
      foreign_address_country: 0,
      permanent_address_line1: 0,
      permanent_address_line2: 0,
      permanent_address_line3: 0,
      permanent_address_postal_code: 0,
      permanent_address_country: 0,
      mailing_address_line1: 0,
      mailing_address_line2: 0,
      mailing_address_line3: 0,
      mailing_address_postal_code: 0,
      mailing_address_country: 0,
      correspondent_address_line1: 0,
      correspondent_address_line2: 0,
      correspondent_address_line3: 0,
      correspondent_address_postal_code: 0,
      correspondent_address_country: 0,
      surname: 0,
      other_name: 0,
      customer_passport_no: 0,
    },

    keyStrokeDynamics: {
      // new
      idProofType: {
        type: "radio",
        weight: 1,
        charCount: 0,
        keyPressCount: 0,
        focusedDuration: 0,
        flags: [],
      },
      customer_passport_no: {
        type: "text",
        weight: 1.75,
        charCount: 0,
        keyPressCount: 0,
        focusedDuration: 0,
        flags: [],
      },
      customer_nic: {
        type: "text",
        weight: 2,
        charCount: 0,
        keyPressCount: 0,
        focusedDuration: 0,
        flags: [],
      },
      nicNumberAllowToLocationServicesInYourBrowser: {
        type: "checkbox",
        weight: 1,
        charCount: 0,
        keyPressCount: 0,
        focusedDuration: 0,
        flags: [],
      },
      title: {
        type: "dropdown",
        weight: 1,
        charCount: 0,
        keyPressCount: 0,
        focusedDuration: 0,
        flags: [],
      },
      account_time_period: {
        type: "dropdown",
        weight: 1,
        charCount: 0,
        keyPressCount: 0,
        focusedDuration: 0,
        flags: [],
      },
      surname: {
        type: "text",
        weight: 1,
        charCount: 0,
        keyPressCount: 0,
        focusedDuration: 0,
        flags: [],
      },
      other_name: {
        type: "text",
        weight: 1,
        charCount: 0,
        keyPressCount: 0,
        focusedDuration: 0,
        flags: [],
      },
      mobileNumber: {
        type: "text",
        weight: 1.55,
        charCount: 0,
        keyPressCount: 0,
        focusedDuration: 0,
        flags: [],
      },
      residentNumber: {
        type: "text",
        weight: 1.55,
        charCount: 0,
        keyPressCount: 0,
        focusedDuration: 0,
        flags: [],
      },
      officeNumber: {
        type: "text",
        weight: 1.55,
        charCount: 0,
        keyPressCount: 0,
        focusedDuration: 0,
        flags: [],
      },
      email: {
        type: "text",
        weight: 1.55,
        charCount: 0,
        keyPressCount: 0,
        focusedDuration: 0,
        flags: [],
      },
      account_type: {
        type: "dropdown",
        weight: 1,
        charCount: 0,
        keyPressCount: 0,
        focusedDuration: 0,
        flags: [],
      },
      account: {
        type: "dropdown",
        weight: 1,
        charCount: 0,
        keyPressCount: 0,
        focusedDuration: 0,
        flags: [],
      },
      forignCurrencyType: {
        type: "dropdown",
        weight: 1,
        charCount: 0,
        keyPressCount: 0,
        focusedDuration: 0,
        flags: [],
      },
      currency_type_code: {
        type: "text",
        weight: 1.75,
        charCount: 0,
        keyPressCount: 0,
        focusedDuration: 0,
        flags: [],
      },
      facility_internet_banking: {
        type: "radio",
        weight: 1,
        charCount: 0,
        keyPressCount: 0,
        focusedDuration: 0,
        flags: [],
      },
      facility_debit_card: {
        type: "radio",
        weight: 1,
        charCount: 0,
        keyPressCount: 0,
        focusedDuration: 0,
        flags: [],
      },

      facility_debit_card_type: {
        type: "radio",
        weight: 1,
        charCount: 0,
        keyPressCount: 0,
        focusedDuration: 0,
        flags: [],
      },
      facility_debit_card_customer_name: {
        type: "text",
        weight: 1.75,
        charCount: 0,
        keyPressCount: 0,
        focusedDuration: 0,
        flags: [],
      },
      yourNewMail: {
        type: "text",
        weight: 1.55,
        charCount: 0,
        keyPressCount: 0,
        focusedDuration: 0,
        flags: [],
      },
      gender: {
        type: "dropdown",
        weight: 1,
        charCount: 0,
        keyPressCount: 0,
        focusedDuration: 0,
        flags: [],
      },
      // date_of_birth: {
      //   type: "dropdown",
      //   weight: 1.5,
      //   charCount: 0,
      //   keyPressCount: 0,
      //   focusedDuration: 0,
      //   flags: [],
      // },
      marital_status: {
        type: "dropdown",
        weight: 1,
        charCount: 0,
        keyPressCount: 0,
        focusedDuration: 0,
        flags: [],
      },
      spouse_name: {
        type: "text",
        weight: 1,
        charCount: 0,
        keyPressCount: 0,
        focusedDuration: 0,
        flags: [],
      },
      citizenship: {
        type: "dropdown",
        weight: 1,
        charCount: 0,
        keyPressCount: 0,
        focusedDuration: 0,
        flags: [],
      },
      dual_citizen_countries: {
        type: "dropdown",
        weight: 1,
        charCount: 0,
        keyPressCount: 0,
        focusedDuration: 0,
        flags: [],
      },
      foreign_national_country: {
        type: "dropdown",
        weight: 1,
        charCount: 0,
        keyPressCount: 0,
        focusedDuration: 0,
        flags: [],
      },
      residentship: {
        type: "radio",
        weight: 1,
        charCount: 0,
        keyPressCount: 0,
        focusedDuration: 0,
        flags: [],
      },
      resident_countries: {
        type: "dropdown",
        weight: 1,
        charCount: 0,
        keyPressCount: 0,
        focusedDuration: 0,
        flags: [],
      },
      resident_country: {
        type: "dropdown",
        weight: 1,
        charCount: 0,
        keyPressCount: 0,
        focusedDuration: 0,
        flags: [],
      },
      permanent_address_line1: {
        type: "text",
        weight: 1.75,
        charCount: 0,
        keyPressCount: 0,
        focusedDuration: 0,
        flags: [],
      },
      permanent_address_line2: {
        type: "text",
        weight: 1.75,
        charCount: 0,
        keyPressCount: 0,
        focusedDuration: 0,
        flags: [],
      },
      permanent_address_line3: {
        type: "text",
        weight: 1.75,
        charCount: 0,
        keyPressCount: 0,
        focusedDuration: 0,
        flags: [],
      },
      permanent_address_postal_code: {
        type: "text",
        weight: 1.75,
        charCount: 0,
        keyPressCount: 0,
        focusedDuration: 0,
        flags: [],
      },
      permanent_address_country: {
        type: "dropdown",
        weight: 1,
        charCount: 0,
        keyPressCount: 0,
        focusedDuration: 0,
        flags: [],
      },
      mailing_address_same_as_permanent_address: {
        type: "checkbox",
        weight: 1,
        charCount: 0,
        keyPressCount: 0,
        focusedDuration: 0,
        flags: [],
      },
      mailing_address_line1: {
        type: "text",
        weight: 1.75,
        charCount: 0,
        keyPressCount: 0,
        focusedDuration: 0,
        flags: [],
      },
      mailing_address_line2: {
        type: "text",
        weight: 1.75,
        charCount: 0,
        keyPressCount: 0,
        focusedDuration: 0,
        flags: [],
      },
      mailing_address_line3: {
        type: "text",
        weight: 1.75,
        charCount: 0,
        keyPressCount: 0,
        focusedDuration: 0,
        flags: [],
      },
      mailing_address_postal_code: {
        type: "text",
        weight: 1.75,
        charCount: 0,
        keyPressCount: 0,
        focusedDuration: 0,
        flags: [],
      },
      mailing_address_country: {
        type: "dropdown",
        weight: 1,
        charCount: 0,
        keyPressCount: 0,
        focusedDuration: 0,
        flags: [],
      },
      us_person: {
        type: "radio",
        weight: 1,
        charCount: 0,
        keyPressCount: 0,
        focusedDuration: 0,
        flags: [],
      },
      us_person_account_numbers: {
        type: "text",
        weight: 1.75,
        charCount: 0,
        keyPressCount: 0,
        focusedDuration: 0,
        flags: [],
      },
      us_person_place_of_birth: {
        type: "text",
        weight: 1.75,
        charCount: 0,
        keyPressCount: 0,
        focusedDuration: 0,
        flags: [],
      },
      permanent_address_in_us_radio: {
        type: "radio",
        weight: 1,
        charCount: 0,
        keyPressCount: 0,
        focusedDuration: 0,
        flags: [],
      },
      correspondent_address_in_us: {
        type: "radio",
        weight: 1,
        charCount: 0,
        keyPressCount: 0,
        focusedDuration: 0,
        flags: [],
      },
      correspondent_address_line1: {
        type: "text",
        weight: 1.75,
        charCount: 0,
        keyPressCount: 0,
        focusedDuration: 0,
        flags: [],
      },
      correspondent_address_line2: {
        type: "text",
        weight: 1.75,
        charCount: 0,
        keyPressCount: 0,
        focusedDuration: 0,
        flags: [],
      },
      correspondent_address_line3: {
        type: "text",
        weight: 1.75,
        charCount: 0,
        keyPressCount: 0,
        focusedDuration: 0,
        flags: [],
      },
      correspondent_address_postal_code: {
        type: "text",
        weight: 1.75,
        charCount: 0,
        keyPressCount: 0,
        focusedDuration: 0,
        flags: [],
      },
      correspondent_address_country: {
        type: "dropdown",
        weight: 1,
        charCount: 0,
        keyPressCount: 0,
        focusedDuration: 0,
        flags: [],
      },
      same_as_above_passport_number: {
        type: "checkbox",
        weight: 1,
        charCount: 0,
        keyPressCount: 0,
        focusedDuration: 0,
        flags: [],
      },
      us_person_passport_no: {
        type: "text",
        weight: 1.75,
        charCount: 0,
        keyPressCount: 0,
        focusedDuration: 0,
        flags: [],
      },
      us_person_tax_identification_no: {
        type: "text",
        weight: 1.75,
        charCount: 0,
        keyPressCount: 0,
        focusedDuration: 0,
        flags: [],
      },
      same_passport_number: {
        type: "checkbox",
        weight: 1,
        charCount: 0,
        keyPressCount: 0,
        focusedDuration: 0,
        flags: [],
      },

      tax_payer: {
        type: "radio",
        weight: 1,
        charCount: 0,
        keyPressCount: 0,
        focusedDuration: 0,
        flags: [],
      },

      politically_exposed_position: {
        type: "text",
        weight: 1.75,
        charCount: 0,
        keyPressCount: 0,
        focusedDuration: 0,
        flags: [],
      },
      us_tel_number:{
        type: "text",
        weight: 1.75,
        charCount: 0,
        keyPressCount: 0,
        focusedDuration: 0,
        flags: [],
      },
      politically_exposed_relative: {
        type: "radio",
        weight: 1,
        charCount: 0,
        keyPressCount: 0,
        focusedDuration: 0,
        flags: [],
      },
      politically_exposed_relative_position: {
        type: "text",
        weight: 1.75,
        charCount: 0,
        keyPressCount: 0,
        focusedDuration: 0,
        flags: [],
      },
      specified_designation: {
        type: "text",
        weight: 1.75,
        charCount: 0,
        keyPressCount: 0,
        focusedDuration: 0,
        flags: [],
      },
      us_person_permanent_address: {
        type: "checkbox",
        weight: 1,
        charCount: 0,
        keyPressCount: 0,
        focusedDuration: 0,
        flags: [],
      },
      us_person_telephone_no: {
        type: "text",
        weight: 1.75,
        charCount: 0,
        keyPressCount: 0,
        focusedDuration: 0,
        flags: [],
      },
      occupation: {
        //newly added **
        type: "dropdown",
        weight: 1,
        charCount: 0,
        keyPressCount: 0,
        focusedDuration: 0,
        flags: [],
      },
      school: {
        type: "text",
        weight: 1.75,
        charCount: 0,
        keyPressCount: 0,
        focusedDuration: 0,
        flags: [],
      },

      purpose_of_opening: {
        type: "dropdown",
        weight: 1,
        charCount: 0,
        keyPressCount: 0,
        focusedDuration: 0,
        flags: [],
      },
      source_of_income: {
        type: "dropdown",
        weight: 1,
        charCount: 0,
        keyPressCount: 0,
        focusedDuration: 0,
        flags: [],
      },
      income_details: {
        type: "dropdown",
        weight: 1,
        charCount: 0,
        keyPressCount: 0,
        focusedDuration: 0,
        flags: [],
      },
      anticipated_vol: {
        type: "dropdown",
        weight: 1,
        charCount: 0,
        keyPressCount: 0,
        focusedDuration: 0,
        flags: [],
      },
      expected_delivery_channel: {
        type: "dropdown",
        weight: 1,
        charCount: 0,
        keyPressCount: 0,
        focusedDuration: 0,
        flags: [],
      },

      videoCallTimeSlot:{
        type: "dropdown",
        weight: 1,
        charCount: 0,
        keyPressCount: 0,
        focusedDuration: 0,
        flags: [],
      },

      employer_name: {
        type: "text",
        weight: 1.5,
        charCount: 0,
        keyPressCount: 0,
        focusedDuration: 0,
        flags: [],
      },
      employer_addr: {
        type: "text",
        weight: 1.5,
        charCount: 0,
        keyPressCount: 0,
        focusedDuration: 0,
        flags: [],
      },
      nic_front_image: {
        type: "file",
        source: null,
        weight: 3,
        charCount: 0,
        keyPressCount: 0,
        focusedDuration: 0,
        flags: [],
      },
      nic_back_image: {
        type: "file",
        source: null,
        weight: 3,
        charCount: 0,
        keyPressCount: 0,
        focusedDuration: 0,
        flags: [],
      },
      selfie_image: {
        type: "file",
        source: null,
        weight: 3,
        charCount: 0,
        keyPressCount: 0,
        focusedDuration: 0,
        flags: [],
      },
      sign_image: {
        type: "file",
        source: null,
        weight: 3,
        charCount: 0,
        keyPressCount: 0,
        focusedDuration: 0,
        flags: [],
      },
      addr_proof_doc: {
        type: "file",
        source: null,
        weight: 3,
        charCount: 0,
        keyPressCount: 0,
        focusedDuration: 0,
        flags: [],
      },
      visa_proof_doc: {
        type: "file",
        source: null,
        weight: 3,
        charCount: 0,
        keyPressCount: 0,
        focusedDuration: 0,
        flags: [],
      },
      passport_image: {
        type: "file",
        source: null,
        weight: 3,
        charCount: 0,
        keyPressCount: 0,
        focusedDuration: 0,
        flags: [],
      },
      introduced_by: {
        type: "text",
        weight: 1.75,
        charCount: 0,
        keyPressCount: 0,
        focusedDuration: 0,
        flags: [],
      },
      agree_with_the_verification_attached: {
        type: "checkbox",
        weight: 1,
        charCount: 0,
        keyPressCount: 0,
        focusedDuration: 0,
        flags: [],
      },

      // old..........................................
      kyc_branch: {
        type: "dropdown",
        weight: 1,
        charCount: 0,
        keyPressCount: 0,
        focusedDuration: 0,
        flags: [],
      },

      branch: {
        type: "dropdown",
        weight: 1,
        charCount: 0,
        keyPressCount: 0,
        focusedDuration: 0,
        flags: [],
      },

      currency_type_raw: {
        type: "dropdown",
        weight: 1,
        charCount: 0,
        keyPressCount: 0,
        focusedDuration: 0,
        flags: [],
      },

      // newly added fields -------------------------------------------------------------------------------------------------

      // newly added fields ends --------------------------------------------------------------------------------------------
      contact_no: {
        type: "text",
        weight: 1.75,
        charCount: 0,
        keyPressCount: 0,
        focusedDuration: 0,
        flags: [],
      },
      contact_no_resident: {
        type: "text",
        weight: 1.75,
        charCount: 0,
        keyPressCount: 0,
        focusedDuration: 0,
        flags: [],
      },
      contact_no_work: {
        type: "text",
        weight: 1.75,
        charCount: 0,
        keyPressCount: 0,
        focusedDuration: 0,
        flags: [],
      },

      name_with_init: {
        type: "text",
        weight: 1.5,
        charCount: 0,
        keyPressCount: 0,
        focusedDuration: 0,
        flags: [],
      },
      full_name: {
        type: "text",
        weight: 1.5,
        charCount: 0,
        keyPressCount: 0,
        focusedDuration: 0,
        flags: [],
      },

      address_line_1: {
        type: "text",
        weight: 1.75,
        charCount: 0,
        keyPressCount: 0,
        focusedDuration: 0,
        flags: [],
      },
      address_line_2: {
        type: "text",
        weight: 1.75,
        charCount: 0,
        keyPressCount: 0,
        focusedDuration: 0,
        flags: [],
      },
      address_line_3: {
        type: "text",
        weight: 1.75,
        charCount: 0,
        keyPressCount: 0,
        focusedDuration: 0,
        flags: [],
      },

      residential_addr: {
        type: "text",
        weight: 1.75,
        charCount: 0,
        keyPressCount: 0,
        focusedDuration: 0,
        flags: [],
      },
      foreign_addr: {
        type: "text",
        weight: 1.75,
        charCount: 0,
        keyPressCount: 0,
        focusedDuration: 0,
        flags: [],
      },
      residential_ownership: {
        type: "dropdown",
        weight: 1,
        charCount: 0,
        keyPressCount: 0,
        focusedDuration: 0,
        flags: [],
      },

      country_of_birth: {
        type: "dropdown",
        weight: 1,
        charCount: 0,
        keyPressCount: 0,
        focusedDuration: 0,
        flags: [],
      },
      nationality: {
        type: "text",
        weight: 1,
        charCount: 0,
        keyPressCount: 0,
        focusedDuration: 0,
        flags: [],
      },

      politically_exposed: {
        type: "radio",
        weight: 2,
        charCount: 0,
        keyPressCount: 0,
        focusedDuration: 0,
        flags: [],
      },

      employment_position: {
        type: "dropdown",
        weight: 1,
        charCount: 0,
        keyPressCount: 0,
        focusedDuration: 0,
        flags: [],
      },

      other_businesses: {
        type: "text",
        weight: 1,
        charCount: 0,
        keyPressCount: 0,
        focusedDuration: 0,
        flags: [],
      },

      facebook_name: {
        type: "text",
        weight: 1,
        charCount: 0,
        keyPressCount: 0,
        focusedDuration: 0,
        flags: [],
      },
      linkedin_name: {
        type: "text",
        weight: 1,
        charCount: 0,
        keyPressCount: 0,
        focusedDuration: 0,
        flags: [],
      },
      twitter_name: {
        type: "text",
        weight: 1,
        charCount: 0,
        keyPressCount: 0,
        focusedDuration: 0,
        flags: [],
      },

      other_purpose_of_opening:{
        type: "text",
        weight: 1,
        charCount: 0,
        keyPressCount: 0,
        focusedDuration: 0,
        flags: [],
      },

      asset_residential_property: {
        type: "checkbox",
        weight: 1,
        charCount: 0,
        keyPressCount: 0,
        focusedDuration: 0,
        flags: [],
      },
      asset_motor_vehicles: {
        type: "checkbox",
        weight: 1,
        charCount: 0,
        keyPressCount: 0,
        focusedDuration: 0,
        flags: [],
      },
      asset_land_buildings: {
        type: "checkbox",
        weight: 1,
        charCount: 0,
        keyPressCount: 0,
        focusedDuration: 0,
        flags: [],
      },
      asset_investments_shares: {
        type: "checkbox",
        weight: 1,
        charCount: 0,
        keyPressCount: 0,
        focusedDuration: 0,
        flags: [],
      },
      asset_other: {
        type: "checkbox",
        weight: 1,
        charCount: 0,
        keyPressCount: 0,
        focusedDuration: 0,
        flags: [],
      },

      asset_residential_property_value: {
        type: "text",
        weight: 1,
        charCount: 0,
        keyPressCount: 0,
        focusedDuration: 0,
        flags: [],
      },
      asset_motor_vehicles_value: {
        type: "text",
        weight: 1,
        charCount: 0,
        keyPressCount: 0,
        focusedDuration: 0,
        flags: [],
      },
      asset_land_buildings_value: {
        type: "text",
        weight: 1,
        charCount: 0,
        keyPressCount: 0,
        focusedDuration: 0,
        flags: [],
      },
      asset_investments_shares_value: {
        type: "text",
        weight: 1,
        charCount: 0,
        keyPressCount: 0,
        focusedDuration: 0,
        flags: [],
      },
      asset_other_value: {
        type: "text",
        weight: 1,
        charCount: 0,
        keyPressCount: 0,
        focusedDuration: 0,
        flags: [],
      },

      //rdb new fields
      address_in_us_same_as_permanent_address: {
        type: "checkbox",
        weight: 1,
        charCount: 0,
        keyPressCount: 0,
        focusedDuration: 0,
        flags: [],
      },
      us_person_permanent_address_line1: {
        type: "text",
        weight: 1,
        charCount: 0,
        keyPressCount: 0,
        focusedDuration: 0,
        flags: [],
      },
      us_person_permanent_address_line2: {
        type: "text",
        weight: 1,
        charCount: 0,
        keyPressCount: 0,
        focusedDuration: 0,
        flags: [],
      },
      us_person_permanent_address_line3: {
        type: "text",
        weight: 1,
        charCount: 0,
        keyPressCount: 0,
        focusedDuration: 0,
        flags: [],
      },
      us_person_permanent_address_postal_code: {
        type: "text",
        weight: 1,
        charCount: 0,
        keyPressCount: 0,
        focusedDuration: 0,
        flags: [],
      },

      us_person_permanent_address_country: {
        type: "text",
        weight: 1,
        charCount: 0,
        keyPressCount: 0,
        focusedDuration: 0,
        flags: [],
      },

      mailing_address_in_us_same_as_permanent_address_in_us: {
        type: "checkbox",
        weight: 1,
        charCount: 0,
        keyPressCount: 0,
        focusedDuration: 0,
        flags: [],
      },
      us_person_mailing_address_line1: {
        type: "text",
        weight: 1,
        charCount: 0,
        keyPressCount: 0,
        focusedDuration: 0,
        flags: [],
      },
      us_person_mailing_address_line2: {
        type: "text",
        weight: 1,
        charCount: 0,
        keyPressCount: 0,
        focusedDuration: 0,
        flags: [],
      },
      us_person_mailing_address_line3: {
        type: "text",
        weight: 1,
        charCount: 0,
        keyPressCount: 0,
        focusedDuration: 0,
        flags: [],
      },
      us_person_mailing_address_postal_code: {
        type: "text",
        weight: 1,
        charCount: 0,
        keyPressCount: 0,
        focusedDuration: 0,
        flags: [],
      },
      us_person_mailing_address_country: {
        type: "text",
        weight: 1,
        charCount: 0,
        keyPressCount: 0,
        focusedDuration: 0,
        flags: [],
      },
    },

    formDataSupport: {
      countriesArray: [],
    },

    kycFieldVisibility: [], // variable to store kyc field visibility data

    isEmailError: false,
    isMobileError: false,
    isCountryCodeError: false,
    engLanguageData: enLanguageData,
    tamLanguageData: taLanguageData,
    sinLanguageData: siLanguageData,
    selectedLanguageData: enLanguageData,
    selectedLanguage: "en",

    isFormSubmitted: false,
  },


  render: (h) => h(App),
}).$mount("#app");
